import { SortingState } from "@tanstack/react-table";
import { LoadingSpinner } from "PFComponents/loading_spinner";
import Table from "PFComponents/table";
import { CustomValueImport } from "PFTypes";
import React, { useState } from "react";

import { useImportSkillsModalContext } from "../../../../contexts/import_skills_modal_context";
import { useImportsHistory } from "../../../../hooks/use_imports_history";
import { parseSorting } from "./helpers";
import { useColumnsGenerator } from "./hooks/use_columns_generator";
import css from "./imports_history_table.module.scss";

const PER_PAGE = 10;

export const ImportsHistoryTable = (): JSX.Element => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState<SortingState>();

  const { search } = useImportSkillsModalContext();
  const generateColumns = useColumnsGenerator();
  const { imports, isLoading, totalPages } = useImportsHistory({
    page: currentPage,
    perPage: PER_PAGE,
    search,
    order: sorting ? parseSorting(sorting) : null
  });

  if (!imports && isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className={css.tableWrapper}>
      <Table<CustomValueImport>
        tableData={imports || []}
        generateColumns={generateColumns}
        paginationOptions={{ totalPages, currentPage, onClick: setCurrentPage }}
        onSortingChange={setSorting}
        controlledSorting={sorting}
      />
    </div>
  );
};
